import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';
import Button from '../Button';
import { PaymentMethodsEnum } from './payment-methods-enum';
import { LocalizationContext } from '../../hoc/Localization';

const paymentSubtypes = [
  {
    key: 'idram',
    title: 'Idram',
    image: '/static/images/course/idram.png',
    text: 'idram.payment.text',
  },
];

const IdramPayment = ({ orderCourse, orderLoading }) => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <div className={styles.paymantContainer}>
      {paymentSubtypes.map(payment => (
        <div className={`${styles.paymentType} ${styles.imageAndText}`} key={payment.key}>
          <Button
            loading={orderLoading === `${PaymentMethodsEnum.IDRAM}-${payment.key}`}
            onClick={() => orderCourse(PaymentMethodsEnum.IDRAM, payment.key)}
          >
            <img src={payment.image} alt={payment.title} />
            <div className={styles.paymentText}>{t(payment.text)}</div>
          </Button>
          <div className={`${styles.paymentText} ${styles.paymentTextSm}`}>{t(payment.text)}</div>
        </div>
      ))}
    </div>
  );
};

IdramPayment.propTypes = {
  orderLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  orderCourse: PropTypes.func.isRequired,
};

IdramPayment.defaultProps = {
  orderLoading: false,
};

export default IdramPayment;
